module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dismiss":"Abandon","lastTransitions":"Last Transitions","resolutions":"Last Errors","resolve":"Try Again"},"fr":{"dismiss":"Abandonner","lastTransitions":"Dernières transitions","resolutions":"Dernières erreurs","resolve":"Réessayer"}}')
  delete Component.options._Ctor
}
